import React, { useState } from 'react'
import { UserHttpService } from '../../../services/user';
import { signInWithApple, signInWithGoogle, signInWithTwitter } from '../../../services/third-party/firebase';
import { setUserSession } from '../../../utils';

function SocialLogin({ hideIntro, ...props }) {

  const [loading,setLoading] = useState(false);
  const [error,setError] = useState("");

  const _signInWithSocial = async (provider = "google") => {
    setLoading(true);
    setError("")
    var response;
    try {
      if (provider === "google") {
        response = await signInWithGoogle()
      } else if (provider === "twitter") {
        response = await signInWithTwitter()
      } else if (provider === "apple") {
        response = await signInWithApple()
      }
    } catch (err) {
      setLoading(false);
      setError(err?.message || "an error occurred while signing in");
      return;
    }

    console.log(response)

    if (response?.uid) {
      UserHttpService.registerSocial(response).then((user) => {
        setLoading(false);
        console.log(user)
        if (user?.error) {
          setError(typeof user.error === "string" ? user.error : "Could not complete social login");
          return;
        }
        if (user?.access || user?.role) {
          setUserSession(user.access, user);
          if (props.setLoggedIn) {
            props.setLoggedIn(user);
          }
          if (user.role == 'admin') {
            window.location.href = "/cms"
          }
          else if (user.role == 'referee') {
            window.location.href = "/referee/dashboard"
          }
          else {
            window.location.href = "/dashboard"
          }
        } else {
          setError("Could not complete social login");
        }
      }).catch(() => {
        setLoading(false);
        setError("Could not reach server to finish social login");
      })
    }
    else {
      setLoading(false);
      setError(response?.errorCode || response?.errorMessage || "an error occurred while signing in")
    }
  }



  return (
    <div className="d-flex flex-column align-items-center social-images lan-kfont lan-rtl">
      {!hideIntro && (
        <p className="text-center mb-0">{"Please sign up or sign in to participate"}</p>
      )}
      <div className={`d-flex justify-content-center flex-gap-3 ${hideIntro ? 'py-0' : 'py-3'}`}>
        <div className="" onClick={() => { !loading && _signInWithSocial("google") }} title="Sign in with google"><img src="assets/images/social/colored/google.png" alt="" /></div>
        <div className="" onClick={() => { !loading && _signInWithSocial("apple") }} title="Sign in with apple"><img className="social-login-icon--apple" src="assets/cms/assets/bower_components/Ionicons/png/512/social-apple.png" alt="" /></div>
        {props?.goToEmailRegister && (
          <div className="" title="Sign in with email and password" onClick={() => { props.goToEmailRegister() }}><img src="assets/images/social/colored/email.png" alt="" /></div>
        )}
      </div>
      {loading && <small className="loading mt-2">Please wait…</small>}
      {error && <div className="alert alert-danger text-2 mt-2 mb-0">{error}</div>}
    </div>
  )
}

export default SocialLogin
